import camelCase from 'lodash/camelCase';
import forEach from 'lodash/forEach';
import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';

/**
 * Objects we import are not always in the same case (camel vs snake)
 * This recursive function will camelCase all keys.
 */
export function objectKeysToCamelCase(snake_case_object) {
  // If provided value is not an object or array, just return the value.
  if (!isPlainObject(snake_case_object) && !isArray(snake_case_object)) {
    return snake_case_object;
  }

  if (isArray(snake_case_object)) {
    // Transform each element of the array
    return snake_case_object.map(objectKeysToCamelCase);
  }

  const result = {};
  forEach(snake_case_object, (value, key) => {
    // Checks if the value is a plain object or an array, for recursive key conversion
    if (isPlainObject(value) || isArray(value)) {
      // Recursively update keys of any value that are also objects or arrays
      result[camelCase(key)] = objectKeysToCamelCase(value);
    } else {
      result[camelCase(key)] = value;
    }
  });

  return result;
}
